interface BarChartProps {
  data: { label: string; value: number; color?: string }[];
  height?: number;
  showValues?: boolean;
  formatValue?: (v: number) => string;
}

export default function BarChart({ data, height = 200, showValues = true, formatValue }: BarChartProps) {
  if (data.length === 0) return <div className="flex items-center justify-center h-48 text-xs text-slate-400">No data</div>;

  const maxVal = Math.max(...data.map(d => d.value), 1);
  const defaultColors = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#06b6d4', '#f97316', '#ec4899', '#14b8a6', '#6366f1', '#84cc16', '#e11d48'];

  return (
    <div className="w-full">
      {/* Y-axis labels + Bars */}
      <div className="flex items-end gap-1" style={{ height }}>
        {data.map((bar, i) => {
          const barHeight = maxVal > 0 ? (bar.value / maxVal) * (height - 28) : 0;
          const color = bar.color || defaultColors[i % defaultColors.length];
          return (
            <div key={i} className="flex-1 flex flex-col items-center justify-end gap-1 group">
              {/* Value */}
              {showValues && bar.value > 0 && (
                <span className="text-[9px] font-black text-slate-700 opacity-0 group-hover:opacity-100 transition-opacity">
                  {formatValue ? formatValue(bar.value) : bar.value.toLocaleString('en-IN')}
                </span>
              )}
              {/* Bar */}
              <div
                className="w-full rounded-t-lg transition-all duration-500 ease-out group-hover:opacity-80 relative overflow-hidden"
                style={{
                  height: Math.max(barHeight, 4),
                  backgroundColor: color,
                  boxShadow: `0 -2px 8px ${color}33`,
                }}
              >
                {/* Shimmer effect */}
                <div className="absolute inset-0 bg-gradient-to-t from-transparent to-white/20" />
              </div>
              {/* Label */}
              <span className="text-[8px] sm:text-[9px] font-bold text-slate-500 text-center leading-tight mt-1 truncate w-full">
                {bar.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
